'use client'

import { useEffect, useState } from 'react';
import { Modal } from 'antd-mobile';
import s from './StandardDom.module.css'

const page = (props)=>{
  const {standardInfo, selectedInfo, confirmStandardFun, setStandardVisiable, standardVisiable} = props;
  
  if(typeof document === 'undefined') return ;
 
  return (
    <Modal
      visible={standardVisiable}
      getContainer={document?.getElementsByClassName('page')?.[0]}
      content={
        <div className={s.content}>
          <div className={s.txt1}>{selectedInfo.cityName}地区</div>
          <div className={s.txt2}>机动车迁入标准为：<span className={s.blue}>{standardInfo?.effluentStandard}及以上</span></div>
          <div className={s.txt2}>该车不符合上牌标准</div>
          
          <div className={s.btncontent}>
            <div className={`${s.btn} ${s.btn1}`} onClick={(() => {  setStandardVisiable(false) })}>换个地区</div>
            <div className={`${s.btn} ${s.btn2}`} onClick={(() => { confirmStandardFun()  })}>确认选择</div>
          </div>
        </div>}
    >

    </Modal>
  )
}

export default page;